import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../interfaces/api.interface';
import {
  Additional,
  CreateAdditionalDto,
  UpdateAdditionalDto,
} from '../interfaces/additional.interface';

/**
 * Сервіс для роботи з додатковими послугами
 */
@Injectable({
  providedIn: 'root',
})
export class AdditionalsService {
  private readonly apiUrl = `${environment.apiUrl}/company/additionals`;

  constructor(private http: HttpClient) {}

  /**
   * Отримати всі додаткові послуги компанії
   */
  getAll(): Observable<ApiResponse<Additional[]>> {
    return this.http.get<ApiResponse<Additional[]>>(this.apiUrl);
  }

  /**
   * Отримати активні додаткові послуги
   */
  getActive(): Observable<ApiResponse<Additional[]>> {
    return this.http.get<ApiResponse<Additional[]>>(`${this.apiUrl}/active`);
  }

  /**
   * Отримати додаткову послугу за ID
   */
  getById(id: number): Observable<ApiResponse<Additional>> {
    return this.http.get<ApiResponse<Additional>>(`${this.apiUrl}/${id}`);
  }

  /**
   * Створити нову додаткову послугу
   */
  create(data: CreateAdditionalDto): Observable<ApiResponse<Additional>> {
    return this.http.post<ApiResponse<Additional>>(this.apiUrl, data);
  }

  /**
   * Оновити додаткову послугу
   */
  update(
    id: number,
    data: UpdateAdditionalDto
  ): Observable<ApiResponse<Additional>> {
    return this.http.put<ApiResponse<Additional>>(
      `${this.apiUrl}/${id}`,
      data
    );
  }

  /**
   * Видалити додаткову послугу
   */
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
